import React from "react";
import "./styles/DesignSolutionContent.scss";
import BannerType1 from "../../../components/BannerType1";
import { useTranslation } from "react-i18next";
const DesignSolutionContent = () => {
  const { t } = useTranslation();
  const flow = t("design.solution.flow.contents", { returnObjects: true }) as string[];
  const contents = t("design.solution.mainContents", { returnObjects: true }) as { path: string; name: string; list: string[] }[];
  return (
    <>
      <div className="design_solution_content_wrap">
        <BannerType1 path="/imgs/banner_design_solution.png" />
        <h2 className="title">{t("design.solution.flow.title")}</h2>
        <div className="content">
          <div className="des">{t("design.solution.flow.des")}</div>
          <div className="flow_wrap">
            <div className="circle_wrap">
              <div className="circle">
                <div className="img_box">
                  <img src="/imgs/step_circle.png" alt="circle" />
                </div>
                <div className="text">{flow[0]}</div>
              </div>
            </div>
            <div className="triangle"></div>
            <div className="circle_wrap">
              <div className="circle">
                <div className="img_box">
                  <img src="/imgs/step_circle.png" alt="circle" />
                </div>
                <div className="text">{flow[1]}</div>
              </div>
            </div>
            <div className="triangle"></div>
            <div className="circle_wrap">
              <div className="circle">
                <div className="img_box">
                  <img src="/imgs/step_circle.png" alt="circle" />
                </div>
                <div className="text">{flow[2]}</div>
              </div>
            </div>
            <div className="triangle"></div>
            <div className="circle_wrap">
              <div className="circle">
                <div className="img_box">
                  <img src="/imgs/step_circle.png" alt="circle" />
                </div>
                <div className="text">{flow[3]}</div>
              </div>
            </div>
            <div className="triangle"></div>
          </div>
          <div className="card_wrap">
            {contents.map((content: { path: string; name: string; list: string[] }, index: number) => {
              return (
                <div className="card" key={`${content.name}_${index}`}>
                  <div className="img_box">
                    <img src={content.path} alt={content.name} />
                  </div>
                  <div className="name">{content.name}</div>
                  <ul>
                    {content.list.map((text: string, index: number) => {
                      return <li key={`${text}_${index}`}>{text}</li>;
                    })}
                  </ul>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default DesignSolutionContent;
